Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.SingleDimensionViewFactory
  constructor: (session) ->
    @session = session
    @factories = [
      new CustomerVisualMode.Charts.DefaultSingleDimensionViewFactory(session),
      new CustomerVisualMode.Charts.HierarchicalDimensionViewFactory(session)
    ]

  canHandle: (widget) ->
    widget.get('type') == CustomerVisualMode.Charts.SingleDimensionView.NAME

  create: (widget, data, isReadOnly, isResponsive) ->
    foundFactory = _.find(@factories, (factory) -> factory.canHandle(widget))
    return null unless foundFactory

    foundFactory.create(widget, data, isReadOnly, isResponsive)

